import { render, staticRenderFns } from "./ticket-detail.vue?vue&type=template&id=07fbea5d&scoped=true&"
import script from "./ticket-detail.vue?vue&type=script&lang=js&"
export * from "./ticket-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fbea5d",
  null
  
)

export default component.exports